import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { TaskPriority } from '@erp/rpc';
import { orpc, rpcClient } from 'src/api/rpc/client';
import { invalidateTaskQueries } from './invalidateTaskQueries';

/** An agent's queue in the order its claim takes tasks (`tasks.agentQueue`). */
export function useAgentTaskQueue(agentDefinitionId: string, enabled = true) {
  return useQuery({
    ...orpc.tasks.agentQueue.queryOptions({
      input: { agentDefinitionId, limit: 200 },
    }),
    enabled: enabled && !!agentDefinitionId,
    refetchInterval: 10_000,
    refetchIntervalInBackground: false,
  });
}

export function useSetQueuedTaskPriority() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: { id: string; priority: TaskPriority }) =>
      rpcClient.tasks.update(input),
    onSuccess: () => invalidateTaskQueries(queryClient),
  });
}

export function useClearQueuedTaskSnooze() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (taskId: string) =>
      rpcClient.tasks.clearSnooze({ taskIds: [taskId] }),
    onSuccess: () => invalidateTaskQueries(queryClient),
  });
}
